module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _vm._v("T"), _c('span', {
    staticClass: "chsmall"
  }, [_vm._v("ABLE of")]), _vm._v(" C"), _c('span', {
    staticClass: "chsmall"
  }, [_vm._v("ONTENTS")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Editors_Preface"
    }
  }, [_vm._v("Editors’ Preface")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Biographical_Note"
    }
  }, [_vm._v("Biographical Note on Oscar Federhen")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/11_A_Capsule_History"
    }
  }, [_vm._v("A Capsule History of the Thirteenth Battery, Massachusetts Light Artillery")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/12_Federhens_Introduction"
    }
  }, [_vm._v("Federhen’s Introduction to the Memoir")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 1: Enlistment and Transport to Louisiana: March and April 1864")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2: Captured by Confederate Troops: May 3, 1864")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3: Marched to Camp Ford: May 5–22, 1864")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4: Held Prisoner in Camp Ford: ca. May–October 1864")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5: The Prisoners’ Tunnel is Discovered")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6: Second Attempt to Escape Camp Ford")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7: Successful Escape from Camp Ford")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8: Walking Across Texas (perhaps autumn 1864)")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9: Encounters with Civilians in Dallas County (perhaps autumn 1864)")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10: Further Travels in Texas")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11: Captured by Confederates Again")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12: Imprisoned in Gainesville, Texas: sometime in early 1865")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13: Escape from Gainesville")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14: More Travels in Texas")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15: Recaptured by Confederates")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16: Imprisoned in Bonham, Texas")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/29_Chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17: Escape from Bonham")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18: In Quantrill’s Camp")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19: Bill Anderson’s Story")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/32_Chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 20: First Raid with Quantrill’s Men")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/33_Chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 21: A Story of a Foraging Party in Missouri")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/34_Chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 22: A Second Raid with Quantrill’s Men")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/35_Chapter23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 23: A Third Raid with Quantrill’s Men")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/36_Chapter24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 24: Battle Between Quantrill’s Men and Confederate Regulars")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/37_Chapter25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 25: Life in Quantrill’s Camp")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/38_Chapter26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 26: Departure from Quantrill’s Camp")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/39_Chapter27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 27: Recaptured by Confederates Again")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/40_Chapter28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 28: Imprisoned Again in Bonham")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/41_Chapter29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 29: A Second Escape from Bonham")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/42_Chapter30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 30: Travel to Shreveport")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/43_Chapter31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 31: Reminiscences of Comanches at Bonham")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/44_Chapter32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 32: Further Travels Toward Shreveport")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/45_Chapter33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 33: Embarking on a Steamboat Towards Federal Lines (May 31, 1865)")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/46_Chapter34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 34: A Steamboat Trip Down the Red River")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/47_Chapter35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 35: Encountering the Union Army (between June 2 and June 6, 1865)")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/48_Chapter36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 36: Reunited with My Unit in New Orleans (June 6, 1865)")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/49_Chapter37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 37: Returning to Boston (July 14–21, 1865)")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/50_Postscript",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Postscript")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/51_Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/52_Acknowledgments",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/53_About_the_Editors",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Editors")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14c103a6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Toc.vue
// module id = 69
// module chunks = 0